import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IConstructionStatistics } from "../domain/IConstructionStatistics";
import { IConstructionStatisticsRequestParams } from "../domain/IConstructionStatisticsRequestParams";
import { StatisticsService } from "../services/statistics.service";

interface OtherProjectsStatisticsState {
  loading: boolean;
  statistics?: IConstructionStatistics;
  error: any;
}

const initialState: OtherProjectsStatisticsState = {
  loading: false,
  statistics: undefined,
  error: undefined,
};

export const getOtherProjectsStatistics = createAsyncThunk(
  "Statistics/getOtherProjectsStatistics",
  async (data?: IConstructionStatisticsRequestParams) => {
    try {
      const result = await StatisticsService.getOtherProjectsStatistics(data);
      return result;
    } catch (err) {
      setError(err);
    }
  }
);

export const OtherProjectsStatisticsSlice = createSlice({
  name: "OtherProjectsStatistics",
  initialState: initialState,
  reducers: {
    setOtherProjectsStatistics: (
      state,
      action: PayloadAction<IConstructionStatistics>
    ) => {
      state.statistics = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOtherProjectsStatistics.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOtherProjectsStatistics.fulfilled, (state, action) => {
      state.loading = false;
      state.statistics = action.payload ? action.payload : undefined;
    });
    builder.addCase(getOtherProjectsStatistics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  }
});

export const selectState = (state: RootState) => state.statistics.otherProjects;

export const { setError } = OtherProjectsStatisticsSlice.actions;

export default OtherProjectsStatisticsSlice.reducer;
